import React from 'react';
import Button from '@mui/material/Button';
import {FormikContext} from 'formik';
import {useWizard} from './WizardNode';
export default function WizardNextNode({children='Next',...props}:any){
 const wizard=useWizard();
 const formik:any=React.useContext(FormikContext as any);
 const handleClick=async(event:any)=>{
  props?.onClick?.(event);
  const errors=await formik?.validateForm?.();
  const touched=(wizard?.fields || []).reduce((acc:any,field:string)=>({...acc,[field]:true}),{});
  if(Object.keys(touched).length) formik?.setTouched?.({...formik?.touched,...touched},true);
  wizard?.reportStepErrors?.(wizard.step, errors);
  if(!errors || Object.keys(errors).length===0) wizard?.next?.();
 };
 return <Button type="button" {...props} onClick={handleClick}>{children}</Button>
}
